import React from "react";
import { useEffect, useState } from "react";
import { PosttransfferPayment, getBankList, getInvestorsSummary, getInvestorsMetadata } from "../../util/APIUtils";
import BankAccListBody from "./BankAccListBody";
import { LoadingOverlay } from "../../util/Helpers";
import InvestorsBody from "./InvestorsBody";
import { Card, CardBody, CardHeader, Input, Button, FormGroup, Label } from "reactstrap";
import { ButtonStyles } from "../../constants/ButtonStyles";

export default function Investors() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [values, setValues] = useState({
    frmDate: new Date().toISOString().substring(0, 10),
    toDate: new Date().toISOString().substring(0, 10),
  });
  const [trans, setTrans] = useState([]);
  const [meta, setMeta] = useState({});
  const [block, setBlock] = useState(false);
  const [transferPayment, setTransferPayment] = useState({
    toBank: "0",
  });
  const [modal, setModal] = useState(false);

  // Data will be loaded after password authentication

  const loadReqData = () => {
    setBlock(true);
    getInvestorsSummary(values).then((response) => {
      setTrans(response);
      setBlock(false);
    });
  };

  const loadMetaData = () => {
    return getInvestorsMetadata().then((response) => {
      const investors = response.filter(i => i.type === "INVESTOR").map(i => ({ id: i.name, name: i.value }));
      const transactionTypes = response.filter(i => i.type === "TransType").map(i => i.value);
      const category = response.filter(i => i.type === "CATEGORY").map(i => ({ id: i.name, name: i.value }));
      setMeta({ investors, transactionTypes, category });
    });
  };

  // model related code
  const updateTransfer = () => {
    if (!validate(transferPayment)) {
      return false;
    }
    setBlock(true);
    PosttransfferPayment(transferPayment).then((response) => {
      setTrans(response);
      setBlock(false);
      cancel();
    });
  };

  const validate = (transferPayment) => {
    if (Object.keys(transferPayment).length != 5) {
      document.getElementById("transError").textContent =
        "Fill all Required Fileds";
      return false;
    } else {
      document.getElementById("transError").textContent = "";
    }
    return true;
  };
  const onChangeTransfer = ({ target }) => {
    const { name, value } = target;
    setTransferPayment((previousState) => ({
      ...previousState,
      [name]: value,
    }));
  };

  const fromBank = (framBank) => {
    let name = "frmBank";
    setTransferPayment((previousState) => ({
      ...previousState,
      [name]: framBank,
    }));
  };

  const cancel = () => {
    setTransferPayment({
      toBank: "0",
    });
    toggle();
  };

  const toggle = () => setModal(!modal);

  const handlePasswordSubmit = () => {
    if (password === "secret") {
      setIsAuthenticated(true);
      setPasswordError("");
      loadReqData();
      loadMetaData();
    } else {
      setPasswordError("Incorrect password!");
    }
  };

  const handlePasswordCancel = () => {
    window.location.href = "#/dashboard";
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handlePasswordSubmit();
    }
  };

  // Show password screen if not authenticated
  if (!isAuthenticated) {
    return (
      <div className="animated fadeIn" style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "70vh"
      }}>
        <Card style={{
          width: "400px",
          borderRadius: "15px",
          boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
          border: "none"
        }}>
          <CardHeader style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            borderRadius: "15px 15px 0 0",
            padding: "20px",
            textAlign: "center"
          }}>
            <i className="fa fa-lock" style={{ fontSize: "40px", color: "#fff", marginBottom: "10px" }}></i>
            <h4 style={{ color: "#fff", margin: "0" }}>Protected Area</h4>
            <p style={{ color: "rgba(255,255,255,0.8)", margin: "5px 0 0 0", fontSize: "14px" }}>
              Enter password to access Investors
            </p>
          </CardHeader>
          <CardBody style={{ padding: "30px" }}>
            <FormGroup>
              <Label style={{ fontWeight: "600", color: "#555", marginBottom: "8px" }}>
                Password
              </Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Enter password"
                style={{
                  borderRadius: "10px",
                  padding: "12px 15px",
                  border: passwordError ? "1px solid #eb3349" : "1px solid #e0e0e0",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.05)"
                }}
              />
              {passwordError && (
                <p style={{ color: "#eb3349", fontSize: "13px", marginTop: "8px", marginBottom: "0" }}>
                  {passwordError}
                </p>
              )}
            </FormGroup>
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <Button
                onClick={handlePasswordSubmit}
                style={{ ...ButtonStyles.primarySm, marginRight: "10px" }}
              >
                <i className="fa fa-unlock" style={{ marginRight: "8px" }}></i>
                Submit
              </Button>
              <Button
                onClick={handlePasswordCancel}
                style={ButtonStyles.secondarySm}
              >
                <i className="fa fa-times" style={{ marginRight: "8px" }}></i>
                Cancel
              </Button>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }

  return (
    <div className="animated fadeIn">
      {block && <LoadingOverlay />}
      <InvestorsBody
        data={trans}
        transferPayment={transferPayment}
        onChangeTransfer={onChangeTransfer}
        cancel={cancel}
        updateTransfer={updateTransfer}
        toggle={toggle}
        modal={modal}
        fromBank={fromBank}
        meta={meta}
        refreshData={loadReqData}
        refreshMeta={loadMetaData}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Investors.js